import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Spinner from "../../Components/Spinner";
import ErrorMessage from "../../Components/ErrorMessage";
import { useParams } from "react-router-dom";
import { useLanguage } from "../../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const ConnectOauthModal = ({
    account_id,
    userData,
    show,
    handleClose,
    selectedMCP,
    setMcpData
}) => {
    const { t } = useLanguage()
    const [loadingSave, setLoadingSave] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });
    const [isAccepted, setIsAccepted] = useState(false);
    const [capabilitiesOpen, setCapabilitiesOpen] = useState(false)
    const { org_id, chat_id } = useParams()

    const toggleCapabillities = () => {
        capabilitiesOpen ? setCapabilitiesOpen(false) : setCapabilitiesOpen(true)
    }

    useEffect(() => {
        if (!show) {
            setIsAccepted(false);
            setErrorMessage({ message: "", display: false });
        }
    }, [show]);

    const closeModal = () => {
        handleClose();
        setErrorMessage({ message: "", display: false });
        setLoadingSave(false);
    };

    const handleConnect = async () => {
        if (!isAccepted) {
            setErrorMessage({ message: t.abilities.auth_req, display: true });
            return;
        }
        setLoadingSave(true)
        setErrorMessage({ message: "", display: false });

        const redirect_uri = window.location.origin;
        if (selectedMCP.system_provider === "Microsoft") {
            try {
                const response = await fetch(`${GEN_BACKEND_LINK}/get_outlook_connection_url`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        account_id,
                        email: userData.email,
                        mcp_id: selectedMCP.id,
                        redirect_uri
                    }),
                });
                const result = await response.json();
                if (result.url) {
                    sessionStorage.setItem("org_id", org_id)
                    if (chat_id) {
                        sessionStorage.setItem("chat_id", chat_id)
                    } else {
                        sessionStorage.removeItem("chat_id")
                    }
                    window.location.href = result.url;
                }
            } catch (err) {
                setLoadingSave(false)
                setErrorMessage({ message: t.error_occurred, display: true });
                console.error("OAuth Error:", err);
            }
            return;
        }

        if (selectedMCP.system_provider === "Google") {
            try {
                const response = await fetch(`${GEN_BACKEND_LINK}/get_gmail_connection_url`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        account_id,
                        email: userData.email,
                        mcp_id: selectedMCP.id,
                        redirect_uri
                    }),
                });
                const result = await response.json();
                if (result.url) {
                    sessionStorage.setItem("org_id", org_id)
                    if (chat_id) {
                        sessionStorage.setItem("chat_id", chat_id)
                    } else {
                        sessionStorage.removeItem("chat_id")
                    }
                    window.location.href = result.url;
                }
            } catch (err) {
                setLoadingSave(false)
                setErrorMessage({ message: t.error_occurred, display: true });
                console.error("OAuth Error:", err);
            }
            return;
        }

        if (selectedMCP.system_provider === "Hubspot") {
            try {
                const response = await fetch(`${GEN_BACKEND_LINK}/get_hs_connection_url`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        account_id,
                        email: userData.email,
                        mcp_id: selectedMCP.id,
                        redirect_uri
                    }),
                });
                const result = await response.json();
                if (result.url) {
                    sessionStorage.setItem("org_id", org_id)
                    if (chat_id) {
                        sessionStorage.setItem("chat_id", chat_id)
                    } else {
                        sessionStorage.removeItem("chat_id")
                    }
                    window.location.href = result.url;
                }
            } catch (err) {
                setLoadingSave(false)
                setErrorMessage({ message: t.error_occurred, display: true });
                console.error("OAuth Error:", err);
            }
            return;
        }

    };

    return (
        <Modal show={show} centered onHide={closeModal} size="md">
            <div className="modal_header">
                <p className="modal_header_title">
                    {selectedMCP?.name}
                    <span>{selectedMCP?.version && `v${selectedMCP?.version}`}</span>
                </p>
            </div>

            <div className="modal_main_cont">

                <div className="persona_reg">


                    {selectedMCP?.creator_name && (
                        <div className="item_content_model">
                            <label className="model_label">{t.abilities.creator}</label>
                            <p>{selectedMCP.creator_name}</p>
                        </div>
                    )}

                    {selectedMCP?.system_provider && (
                        <div className="item_content_model">
                                <label className="model_label">{t.abilities.sys_provider}</label>
                            <p>{selectedMCP.system_provider}</p>
                        </div>
                    )}
                </div>

                {selectedMCP?.description && (
                    <div className="item_content_model">
                            <label className="model_label">{t.description}</label>
                        <p>{selectedMCP.description}</p>
                    </div>
                )}

                {selectedMCP?.env_vars && selectedMCP.env_vars.length > 0 && (
                    <div className="item_content_model">
                            <label className="model_label">{t.abilities.config_req}</label>
                        <div className="config_cont">
                            {selectedMCP.env_vars.map((env_var) => (
                                <p className="config_cont_pill">
                                    {env_var}
                                </p>
                            ))}
                        </div>
                    </div>
                )}

                <div className="item_content_model">
                        <label className="model_label">{t.abilities.authorization}</label>
                    <div className="authorization_cont" onClick={(e) => setIsAccepted(e.target.checked)}>
                        <input
                            type="checkbox"
                            id="accept_mcp"
                            checked={isAccepted}
                            onClick={(e) => setIsAccepted(e.target.checked)}
                        />
                        <label htmlFor="accept_mcp" >
                               {t.abilities.i_auth}
                        </label>
                    </div>
                </div>

            </div>

            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        disabled={loadingSave}
                        onClick={handleConnect}
                    >
                        {loadingSave ? <Spinner loading={true} /> : t.connect}
                    </button>

                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                        disabled={loadingSave}
                    >
                        {t.close}
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default ConnectOauthModal;